import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Box, FormControl, TextField, makeStyles, Typography } from "@material-ui/core";
import ReactDatePicker from "react-datepicker";
import FilterComponent from "./FilterComponent";

const useStyles = makeStyles((theme) => ({
  datepickerInput: {
    "& .MuiInputBase-input, & .MuiOutlinedInput-input": {
      height: "40px", 
      padding: "0px",
      textAlign: "center",
      border: `1px solid ${theme.palette.grey.medium}`,
      borderRadius: "4px",
      "&:hover": {
        borderColor: theme.palette.primary.main,
      },
    },
  },
  separateContainer: {
    width: "150px",
    marginRight: "20px",
  },
  nameInput: {
    height: "3px",
    border: `1px solid ${theme.palette.grey.medium}`,
    borderRadius: "4px",
    "&:hover": {
      borderColor: theme.palette.primary.main,
    },
  },
  errorText: {
    color: "red",
    marginTop: "8px",
    fontSize: "0.875rem",
  },
}));

const FilterComponentsGrid = ({
  filters,
  startDateState,
  handleSetStartDate,
  endDateState,
  handleSetEndDate,
  name,
  handleNameChange,
  handleFilterChange,
}) => {
  const classes = useStyles();
  const [dateError, setDateError] = useState("");

  const handleDateChange = (newDate, setFunction) => {
    const isValidRange =
      (setFunction === handleSetStartDate && newDate <= endDateState) ||
      (setFunction === handleSetEndDate && newDate >= startDateState);
  
    const dateError = isValidRange ? "" : "Start date cannot be later than end date";
    setDateError(dateError);
    setFunction(newDate);
  };

  useEffect(() => {
    filters.forEach((filter) => {
      const sessionKey = `filterState_${filter.name}`;
      const savedValue = sessionStorage.getItem(sessionKey);
      if (savedValue) {
        handleFilterChange(filter.name, savedValue);
      }
    });
  }, [filters, handleFilterChange]);

  return (
    <Box display="flex" flexWrap="wrap">
      <Box className={classes.separateContainer}>
        <h4>Start date:</h4>
        <ReactDatePicker
          showIcon
          selected={startDateState}
          onChange={(date) => handleDateChange(date, handleSetStartDate)}
          dateFormat="MM/yyyy"
          showMonthYearPicker
          customInput={
            <TextField variant="outlined" className={classes.datepickerInput} />
          }
          minDate={new Date(2000, 0, 1)}
        />
        {dateError && (
        <Typography className={classes.errorText}>{dateError}</Typography>
      )}
      </Box>
      <Box className={classes.separateContainer}>
        <h4>End date:</h4>
        <ReactDatePicker
          showIcon
          selected={endDateState}
          onChange={(date) => handleDateChange(date, handleSetEndDate)}
          dateFormat="MM/yyyy"
          showMonthYearPicker
          className={classes.separateContainer}
          customInput={
            <TextField variant="outlined" className={classes.datepickerInput} />
          }
          minDate={new Date(2000, 0, 1)}
        />
      </Box>
      <Box className={classes.separateContainer}>
        <FormControl>
          <h4>Name:</h4>
          <TextField
            id="nameInput"
            value={name}
            onChange={handleNameChange}
            placeholder="Enter a name"
            variant="outlined"
            style={{ height: "3px !important", width: "150px" }}
            InputProps={{ classes: { input: classes.nameInput } }}
          />
        </FormControl>
      </Box>
      {filters.map(
        (filter) =>
          filter.filtersListMembers.length > 0 && (
            <Box key={filter.id} marginRight="20px">
              <FilterComponent
                filter={filter}
                onFilterChange={handleFilterChange}
              />
            </Box>
          )
      )}
    </Box>
  );
};

FilterComponentsGrid.propTypes = {
  filters: PropTypes.array.isRequired,
  startDateState: PropTypes.instanceOf(Date).isRequired,
  handleSetStartDate: PropTypes.func.isRequired,
  endDateState: PropTypes.instanceOf(Date).isRequired,
  handleSetEndDate: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  handleNameChange: PropTypes.func.isRequired,
  handleFilterChange: PropTypes.func.isRequired,
};

export default FilterComponentsGrid;
